define("shared/utils/string-formatters/dashed-to-camel", ["exports", "@ember/string"], function (_exports, _string) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/string"eaimeta@70e063a35619d71f
  /**
   * @module Utils
   */
  /**
   * @class dashedToCamel
   * @extends Utils
   */
  /** Returns a camel cased version of the given dasherized string
   *
   * @method dashedToCamel
   * @param {String} str dasherized string
   *
   * @returns {String} Camel cased version of str
   * @protected
   */
  var _default = str => {
    if (typeof str !== 'string') {
      return str;
    }
    return (0, _string.camelize)(str.toLowerCase());
  };
  _exports.default = _default;
});